/*******************************************************************************
* Licensed Materials - Property of HCL 
* (c) Copyright HCL Technologies Ltd. 2020. All Rights Reserved. 

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/
import React from "react";
import PropTypes from "prop-types";
import Text from "./Text";
import Button from "./Button";
import SelectionButton from "./SelectionButton";

function RangeSelectionPanel({
    width,
    height,
    fontColor,
    button,
    from,
    to,
    textSize,
    title,
    aframeClasses
}) {
    return (
        <a-entity
            position={`${-width / 2 + width * 0.05} ${
                height / 2 - height / 10
            } 0.01`}
        >
            <Text
                value={title}
                width={width * (button ? 0.7 : 0.9)}
                align="left"
                sizeDecimal={textSize * 0.8}
                baseline="top"
                color={fontColor}
            />
            {button && (
                <Button
                    text={button.text}
                    width={(width * 0.8) / 4}
                    height={height / 5}
                    textSizeDecimal={textSize}
                    aframeClasses={aframeClasses}
                    position={`${width * 0.8} ${-height / 10} 0`}
                    type={Button.constants.primary}
                    disabled={!button.isButtonEnabled}
                    onClickHandler={button.onClick}
                />
            )}
            <Text
                text={from.text}
                width={width / 2}
                align="left"
                sizeDecimal={textSize}
                color={fontColor}
                position={`0 ${-height / 5 - (height / 10) * 2} 0`}
            />
            <Text
                text={to.text}
                width={width / 2}
                align="left"
                sizeDecimal={textSize}
                color={fontColor}
                position={`${((width * 0.92) / 4) * 2} ${
                    -height / 5 - (height / 10) * 2
                } 0`}
            />
            <SelectionButton
                id={from.text + from.choices[0]}
                width={(width * 0.8) / 2}
                height={height / 5}
                choices={from.choices}
                current={from.current}
                setCurrent={from.setCurrent}
                aframeClasses={aframeClasses}
                position={`${(width * 0.8) / 4} ${
                    -height / 5 - (height / 10) * 4
                } 0`}
                textSizeDecimal={textSize}
            />
            <SelectionButton
                id={to.text + to.choices[0]}
                width={(width * 0.8) / 2}
                height={height / 5}
                choices={to.choices}
                current={to.current}
                setCurrent={to.setCurrent}
                aframeClasses={aframeClasses}
                position={`${((width * 0.9) / 4) * 3} ${
                    -height / 5 - (height / 10) * 4
                } 0`}
                textSizeDecimal={textSize}
            />
        </a-entity>
    );
}

RangeSelectionPanel.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    title: PropTypes.string.isRequired,
    textSize: PropTypes.number.isRequired
};

export default RangeSelectionPanel;
